import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/languex-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/notFound.png");
